import confetti from 'canvas-confetti';

/**
 * Example usage:
 *   <button
 *     is="favorite-post"
 *     post-id="342"  //what post ID is this button for? 
 *     title="ABC Company" // the title of the Post this if favoriting
 *     count-selector=".favorite-count" //a JS selector to update with the total favorite count
 *     colors="#FF3B30,#FF9500,#FFCC00,#34C759,#007AFF,#5856D6,#AF52DE" // a CSV of HEX colors
 *    count="10" // how many
 *    velocity="20" // how fast
 *   >[anything goes in here]</button>
 */

const cookieName = "favorites" //the name of the cookie we save to

class FavoritePost extends HTMLButtonElement {

  connectedCallback(){

    if(this.initialized){
      return
    }
    this.initialized = true

    if(!this.hasAttribute('title')){
      console.warn("Favorite post button missing a title!", this)
    }

    this.addEventListener('click', e => this._handleClick(e))

    this._updateFavoritedState(this._isInFavorites())

    this._updateCounter()
  }

  //checks if this element's post-id is in the cookie
  _isInFavorites(){
    const id = parseInt(this.getAttribute('post-id'))
    const cookie = window.coolHelperFunctions.getCookie(cookieName)
    if(cookie){
      return JSON.parse(cookie).indexOf(id) != -1
    } else {
      return false
    }
  }

  _handleClick(e){
    e.preventDefault()
    if(this._isInFavorites()){
      this._removeFromFavorites()
    } else {
      const colors = this.getAttribute('confetti-colors') || "#FF3B30,#FF9500,#FFCC00,#34C759,#007AFF,#5856D6,#AF52DE"
      confetti({
        disableForReducedMotion: true,
        ticks: 70,
        gravity: 0.5,
        colors: colors.split(',').map(t => t.trim()),
        particleCount: this.getAttribute('confetti-count') || 7,
        startVelocity: this.getAttribute('confetti-velocity') || 10,
        origin: {
          x: (e.clientX / window.innerWidth),
          y: (e.clientY / window.innerHeight)
        }
      })
      this._addToFavorites()
    }
    this._updateCounter()
  }

  //add this element's post-id to the cookie
  _addToFavorites(){
    const id = parseInt(this.getAttribute('post-id'))
    let cookie = window.coolHelperFunctions.getCookie(cookieName)
    if(cookie){
      cookie = JSON.parse(cookie)
      cookie.push(id)
      window.coolHelperFunctions.setCookie(cookieName, JSON.stringify(cookie), 3650)
    } else {
      window.coolHelperFunctions.setCookie(cookieName, JSON.stringify([ id ]), 3650)
    }
    this._updateFavoritedState(true)
    document.querySelectorAll(`button[is="favorite-post"][post-id="${id}"]`).forEach(t => t._updateFavoritedState(true))
  }

  //remove this element's post-id from the cookie
  _removeFromFavorites(){
    const id = parseInt(this.getAttribute('post-id'))
    let cookie = window.coolHelperFunctions.getCookie(cookieName)
    if(cookie){
      cookie = JSON.parse(cookie).filter(i => i != id)
      window.coolHelperFunctions.setCookie(cookieName, JSON.stringify(cookie), 3650)
    }
  
    this._updateFavoritedState(false)
    document.querySelectorAll(`button[is="favorite-post"][post-id="${id}"]`).forEach(t => t._updateFavoritedState(false))
  }

  //updates a counter for total
  _updateCounter(){
    const counters = this.getAttribute('count-selector') ? document.querySelectorAll(`${this.getAttribute('count-selector')}`) : null
    if(counters){
      let total = 0
      let cookie = window.coolHelperFunctions.getCookie(cookieName)
      if(cookie){
        total = JSON.parse(cookie).length
      }
      counters.forEach(c => c.innerHTML = total)
    }
  }

  _updateFavoritedState(isFav){
    if(isFav){
      this.classList.add('favorited')
      this.setAttribute('aria-label', `Remove from favorites: ${this.getAttribute('title')}`)
    } else {
      this.classList.remove('favorited')
      this.setAttribute('aria-label', `Add to favorites: ${this.getAttribute('title')}`)
    }
  }

}

customElements.define("favorite-post", FavoritePost, { extends: 'button' })